import { createSlice } from '@reduxjs/toolkit'

export const UsersSlice = createSlice({
  name: 'user',
  initialState: {
    users: [],
  },
  reducers: {
    setUsers: (state, action) => {
      state.users = action.payload
    },
    addUser: (state, action) => {
      state.users.push(action.payload)
    },
    editUser: (state, action) => {
      state.users = state.users.map((user) => {
        if (user.id != action.payload.id) return user
        else {
          return action.payload
        }
      })
    },
    removeUser: (state, action) => {
      state.users = state.users.filter((user) => user.id != action.payload)
    },
  },
})

// Action creators are generated for each case reducer function
export const { setUsers, addUser, removeUser, editUser } = UsersSlice.actions

export default UsersSlice.reducer
